<template>
  <div class="menuContainer">
    <div class="menuList">
      <img @click="switchMenu" class="icon_close" src="static/images/icon_close.png" alt="">

      <div class="menuOuter" @click="onClick(item)" v-for="item in dataList" v-bind:key="item.name">
        <div class="menuInner">
          <img :src="item.iconLink" alt="">
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>
    <transition name="fade-menu">
      <AboutHenkel v-if="about" @onClick="onClick" />
    </transition>
  </div>
</template>

<script>
import AboutHenkel from '../AboutHenkel'
// import BaseModalContentLayout from '../BaseModalContentLayout'
const dataList = [
  { name: '活动预约', type: 'link', url: 'http://baidu.com/', iconLink: 'static/images/activity_reservation.png' },
  { name: '品牌直播', type: '', iconLink: 'static/images/brand_live.png' },
  { name: '电商云店', type: 'path', path: '/store', iconLink: 'static/images/cloud_store.png' },
  { name: '业务咨询', type: 'path', path: '/consult', iconLink: 'static/images/business_consulting.png' },
  { name: '媒体中心', type: 'popup', iconLink: 'static/images/media_center.png' },
  { name: '关于汉高', type: 'about', iconLink: 'static/images/about_henkel.png' }
]
export default {
  name: 'MenuList',
  components: {
    AboutHenkel
  },
  props: {
  },
  data () {
    return {
      about: false
    }
  },
  created () {
    this.dataList = dataList
  },
  methods: {
    switchMenu () {
      this.$emit('switchMenu')
    },
    onClick (record) {
      switch (record.type) {
        case 'about':
          this.about = !this.about
          break
        case 'link':
          window.location.href = record.url
          break
        case 'path':
          this.$router.push(record.path)
          break

        default:
          console.log('oops...')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.menuContainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  .menuList {
    width: 610px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    justify-content: space-between;

    .icon_close {
      width: 47px;
      height: 47px;
      position: absolute;
      right: 0;
      top: -60px;
    }
  }
  .menuOuter {
    width: 286px;
    height: 286px;
    display: flex;
    margin-bottom: 40px;
    justify-content: center;
    align-items: center;
    border-bottom-right-radius: 40px;
    background-image: linear-gradient(#f00a0a, #e10010);

    .menuInner {
      width: 260px;
      height: 260px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(#fa1f1f, #e40616);
      box-shadow: 0 0 7px rgba(199, 0, 6, 0.2);

      img {
        width: 100px;
      }

      span {
        font-size: 30px;
        color: #fff;
        margin-top: 20px;
      }
    }
  }

  .fade-menu-enter-active, .fade-menu-leave-active {
    transition: all 0.3s ease;
  }
  .fade-menu-enter, .fade-menu-leave-to {
    opacity: 0;
  }
}
</style>
